@font-face {
  font-family: 'Kohinoor';
  src: url('../public/fonts/KohinoorBangla/KohinoorBangla-Medium.otf');
}

.app {
  font-family: 'Montserrat', 'Open Sans', 'Lucidia Grande', 'Roboto', sans-serif;
}

*,
:before,
:after {
  box-sizing: border-box;
}

body {
  margin: 0;
}

input, button {
  line-height: inherit;
}

a {
  text-decoration: none;
}

a:hover {
  cursor: pointer;
}

:root {
  --promo-bg-color: #e3e3e8;
  --main-bg-color: #f4f4f6;
  --sidebar-bg-color: #001628;
  --navbar-selected-button-text-color: #4786e9;
  --deposit-withdraw-bg-color: #ffffff;

  --navbar-bg-color: hsla(240, 10%, 90%, 1);

  --green-primary-color: hsla(31, 88%, 48%, 1);
  --green-primary-bg-color: hsla(31, 88%, 42%, 1);
  --green-primary-hvr-color: hsla(31, 88%, 40%, 1);

  --green-secondary-color: hsla(36, 41%, 27%, 1);
  --green-secondary-bg-color: hsla(35, 38%, 36%, 1);
  --green-secondary-hvr-color: hsla(36, 41%, 27%, 1);

  --grey-text-subtitle-color: #838e9f;

  --button-bg-color: #1a73e8;
  --button-bg-hover-color: #1365d1;

  --button-border-color: #008be9;
  --button-border-hover-color: #008be9;

  --disabled-button-bg-color: #c4d8fb;
  --disabled-button-text-color: #56759e;
  --disabled-button-border-color: #bcd7f3;
  --red-text-color: #d62650;

  --deal-border-color: #a0a3a8;

  /* purchase alerts  */
  --purchase-warning-color: #f4b528;
  --purchase-success-color: #5bcd8c;
  --purchase-error-color: #e1334e;
  --purchase-warning-bg-color: #fef8e3;
  --purchase-success-bg-color: #e7faf2;
  --purchase-error-bg-color: #fae8eb;
  --purchase-default-text-color: #282923;

  /* login - styling */
  --login-text-color: hsla(31, 88%, 52%, 1);
  --login-border-color: hsla(31, 88%, 52%, 1);
  --login-bg-color: hsla(31, 88%, 52%, 0.92);
  --login-hvr-color: hsla(31, 88%, 52%, 1);
  --about-texts-color: #ffffff;
  --white-color: #ffffff;
  --signin-btn-bg-color: #ffffff;

  /* Password Reset and Login Page Label Style  */
  --reset-password-label-color: #7b8784;
  --login-error-message-color: #d62650;

  /* overview */
  --default-text-color: #141414;
  --default-text-secondary-color: #273746;
  --default-footer-attribute-color: #6c6b6b;

  /* portfolio */
  --deal-portfolio-attributes-color: #a2a5aa;
  --deal-portfolio-attributes-INR-color: #4a9864;
  --default-border-color: #696969;
  --portfolio-tab-color: #3674d7;

  /* deal cards  */
  --deal-card-bg-color: #ffffff;
  --deal-attributes-color: #a2a5aa;
  --deal-attributes-INR-color: #4a9864;
  --deal-attributes-value-color: #001628;
  --selected-footer-attribbute-color: #1a73e8;

  /* profile  */
  --profile-active-text-color: #3674d7;
  --profile-active-bg-color: #dfe9fb;
  --default-profile-text-color: #2c3e50;

  --footer-bg-color: #dadde2;

  /* Register Attributes */
  --register-attributes-message-success: #35a37e;
  --register-attributes-message-failure: #d62650;
  --register-attributes-message-warning: #d19d24;
  --register-attributes-details: #808b96;
  --register-attributes-label: #566573;

  /* --main-bg-color: #EFB6D4; */
  /* --sidebar-bg-color:  #25252c; */
  /* --sidebar-bg-color: #001628; */
  /* --sidebar-bg-color: #1c2534; */

  /* --navbar-bg-color: #f5f5f7; */
  /* --promo-bg-color: #e3e3e8;
  --green-primary-color: #43cea2;
  --green-primary-bg-color: #EEFBFF;
  --green-primary-hvr-color: #cedce0;
  --green-secondary-color: #5CBE7D;
  --green-secondary-bg-color: #fff;
  --green-secondary-hvr-color: #FAF8FF; */
  /* --button-bg-color: #1a73e8; 
  --button-bg-hover-color: #1365d1;
  
  --red-text-color: #d62650;
  */

  /* --button-bg-color: #0098F7;
  --button-bg-hover-color: #0382d1;
  --disabled-button-bg-color:#E8F3F1;
  --button-border-color: #008BE9;
  --button-border-hover-color: #008BE9;
  --red-text-color: #d62650; */

  --scale-card: scale(1);

  --modal-close-icon-size: 1.35rem;

  /* font sizing */
  /* This must be in the last */
  --base-font-size: calc(9px + 0.390625vw);
  font-size: var(--base-font-size);
  scroll-behavior: smooth;
  line-height: 1.5715;
}
